/**
 * Plot Pavings Field Mapping
 * Maps field names to their display labels (matching groundworks_rates_mapping.json)
 */

export const PLOT_SLABS_FIELD_LABELS: { [fieldName: string]: string } = {
  // Paving Paths
  'pavingLevelCompact': 'Level and compact formation',
  'pavingGeotextileLayer': 'Geotextile Layer',
  'pavingSubBase': 'xxxmm thick Stone bed',
  'pavingPlainGreyPavings': 'Slabs',
  'slab900wSteps': 'EO for forming steps - 900mm wide',
  'slab1200wSteps': 'EO for forming steps - 1200mm wide',
  'slabGravelMarginPea': '10mm/20mm gravel in 150mm wide margin to house path',
  'slabGravelMarginCotswold': 'Cotswold gravel in 150mm wide margin to house path',
  'slabThresholdDrain': 'Threshold drain to fronts only',
  'slabShedBase': 'Shed Base',
  'slabCycleHoops': 'Sheffield cycle hoops',
  'slabRotaryDryer': 'Fix only rotary dryers',

  // Macadam Paths
  'macadamLevelCompact': 'Level and compact formation',
  'macadamGeotextileLayer': 'Geotextile Layer',
  'macadamSubBase': 'xxxmm thick MOT Type 1',
  'macadamDbBase': 'xxmm DB Base',
  'macadamDbBinder': 'xxmm DB Binder',
  'macadamSealingGrit': 'Sealing Grit',
  'macadamSweepTack': 'Sweep & Tack coat',
  'macadamDbSurfaceCourse': 'xxmm DB Surface course',
  'macadamHraSurfaceCourse': 'xxmm HRA Surface course',
  'macadamSmaSurfaceCourse': 'xxmm SMA Surface course',
  'macadamEdgings': 'Edgings 150 x 50',
};

/**
 * Units for Plot Pavings fields
 */
export const PLOT_SLABS_FIELD_UNITS: { [fieldName: string]: string } = {
  // Paving Paths - m²
  'pavingLevelCompact': 'm²',
  'pavingGeotextileLayer': 'm²',
  'pavingSubBase': 'm²',
  'pavingPlainGreyPavings': 'm²',
  // Paving Paths - Nr
  'slab900wSteps': 'Nr',
  'slab1200wSteps': 'Nr',
  'slabGravelMarginPea': 'Nr',
  'slabGravelMarginCotswold': 'Nr',
  'slabThresholdDrain': 'Nr',
  'slabShedBase': 'Nr',
  'slabCycleHoops': 'Nr',
  'slabRotaryDryer': 'Nr',

  // Macadam Paths - m²
  'macadamLevelCompact': 'm²',
  'macadamGeotextileLayer': 'm²',
  'macadamSubBase': 'm²',
  'macadamDbBase': 'm²',
  'macadamDbBinder': 'm²',
  'macadamSealingGrit': 'm²',
  'macadamSweepTack': 'm²',
  'macadamDbSurfaceCourse': 'm²',
  'macadamHraSurfaceCourse': 'm²',
  'macadamSmaSurfaceCourse': 'm²',
  // Macadam Paths - m
  'macadamEdgings': 'm',
};

/**
 * Get the display label for a Plot Pavings field
 */
export function getPlotPavingsFieldLabel(fieldName: string): string | null {
  return PLOT_SLABS_FIELD_LABELS[fieldName] || null;
}

/**
 * Get the unit for a Plot Pavings field
 */
export function getPlotPavingsFieldUnit(fieldName: string): string | null {
  return PLOT_SLABS_FIELD_UNITS[fieldName] || null;
}
